export default "__VITE_ASSET__BTOUEoRo__"